module.exports = __webpack_public_path__ + "static/media/triangle.da5615a2.png";